import { render, staticRenderFns } from "./CompProfileEditPicture.vue?vue&type=template&id=c7154de6&scoped=true"
import script from "./CompProfileEditPicture.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileEditPicture.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7154de6",
  null
  
)

export default component.exports